import React, { useState, useEffect, useRef } from 'react';
import '../styles/Pages/Contact.css';

/* ══════════════════════════════════════
   GSAP LOADER
══════════════════════════════════════ */
function loadGSAP() {
  return new Promise((resolve) => {
    if (window.gsap && window.ScrollTrigger) { resolve(); return; }
    const s1 = document.createElement('script');
    s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      s2.onload = () => { window.gsap.registerPlugin(window.ScrollTrigger); resolve(); };
      document.head.appendChild(s2);
    };
    document.head.appendChild(s1);
  });
}

/* ══════════════════════════════════════
   CUSTOM SVG ICONS
══════════════════════════════════════ */
const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.23a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.48h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l.72-.72a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 17.92z"/>
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);
const IconTwitterX = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
const IconGithub = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/>
  </svg>
);
const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconChevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

/* ── Info card icons map ── */
const INFO_ICONS = [<IconPin/>, <IconPhone/>, <IconMail/>, <IconClock/>];
const INFO_COLORS = ['#2f80ed','#10b981','#56ccf2','#f59e0b'];

/* ══════════════════════════════════════
   PARTICLE CANVAS
══════════════════════════════════════ */
function ParticleField() {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext('2d'); let W,H,pts,raf;
    const resize=()=>{W=c.width=c.offsetWidth;H=c.height=c.offsetHeight;};
    const make=()=>({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.25,vy:(Math.random()-.5)*.25,r:Math.random()*1.3+.3,a:Math.random()*.35+.07});
    const init=()=>{resize();pts=Array.from({length:50},make);};
    const draw=()=>{
      ctx.clearRect(0,0,W,H);
      pts.forEach(p=>{p.x+=p.vx;p.y+=p.vy;if(p.x<0)p.x=W;if(p.x>W)p.x=0;if(p.y<0)p.y=H;if(p.y>H)p.y=0;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);ctx.fillStyle=`rgba(47,128,237,${p.a})`;ctx.fill();});
      for(let i=0;i<pts.length;i++)for(let j=i+1;j<pts.length;j++){const dx=pts[i].x-pts[j].x,dy=pts[i].y-pts[j].y,d=Math.sqrt(dx*dx+dy*dy);if(d<90){ctx.beginPath();ctx.moveTo(pts[i].x,pts[i].y);ctx.lineTo(pts[j].x,pts[j].y);ctx.strokeStyle=`rgba(47,128,237,${.1*(1-d/90)})`;ctx.lineWidth=.5;ctx.stroke();}}
      raf=requestAnimationFrame(draw);
    };
    init();draw();
    window.addEventListener('resize',init);
    return()=>{cancelAnimationFrame(raf);window.removeEventListener('resize',init);};
  },[]);
  return <canvas ref={ref} className="con-canvas" aria-hidden />;
}

/* ══════════════════════════════════════
   FAQ ACCORDION ITEM
══════════════════════════════════════ */
function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.style.maxHeight = open ? bodyRef.current.scrollHeight + 'px' : '0px';
    }
  }, [open]);

  return (
    <div className={`faq-item ${open ? 'faq-open' : ''}`} style={{ '--fi': index }}>
      <button className="faq-trigger" onClick={() => setOpen(o => !o)} aria-expanded={open}>
        <span className="faq-q">{faq.question}</span>
        <span className="faq-chevron"><IconChevron /></span>
      </button>
      <div className="faq-body" ref={bodyRef}>
        <p className="faq-ans">{faq.answer}</p>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════
   MAP PLACEHOLDER — animated nodes
══════════════════════════════════════ */
function MapViz() {
  return (
    <div className="map-viz">
      <div className="map-grid-bg" aria-hidden />
      <div className="map-glow" aria-hidden />
      {/* pin */}
      <div className="map-pin-wrap">
        <div className="map-pin">
          <IconPin />
        </div>
        <div className="map-ping r1" />
        <div className="map-ping r2" />
        <div className="map-ping r3" />
      </div>
      {/* floating info card */}
      <div className="map-card">
        <div className="map-card-icon"><IconPin /></div>
        <div>
          <p className="map-card-name">Incogniflex HQ</p>
          <p className="map-card-addr">1 Market St, Suite 2600<br />San Francisco, CA 94103</p>
        </div>
      </div>
      {/* decorative connection nodes */}
      {[
        { top:'20%', left:'15%', delay:'0s' },
        { top:'65%', left:'75%', delay:'.4s' },
        { top:'35%', left:'82%', delay:'.8s' },
        { top:'75%', left:'20%', delay:'1.2s' },
      ].map((n, i) => (
        <div key={i} className="map-node" style={{ top:n.top, left:n.left, animationDelay:n.delay }} />
      ))}
      <svg className="map-connections" viewBox="0 0 100 100" preserveAspectRatio="none">
        <line x1="50" y1="50" x2="15" y2="20" stroke="rgba(47,128,237,0.2)" strokeWidth="0.3" strokeDasharray="2 3"/>
        <line x1="50" y1="50" x2="75" y2="65" stroke="rgba(47,128,237,0.2)" strokeWidth="0.3" strokeDasharray="2 3"/>
        <line x1="50" y1="50" x2="82" y2="35" stroke="rgba(47,128,237,0.15)" strokeWidth="0.3" strokeDasharray="2 3"/>
        <line x1="50" y1="50" x2="20" y2="75" stroke="rgba(47,128,237,0.15)" strokeWidth="0.3" strokeDasharray="2 3"/>
      </svg>
    </div>
  );
}

/* ══════════════════════════════════════
   MAIN CONTACT COMPONENT
══════════════════════════════════════ */
const Contact = () => {
  const [formData, setFormData] = useState({ name:'', email:'', company:'', service:'', message:'' });
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState('');
  const [focused,  setFocused]  = useState('');
  const formRef = useRef(null);

  /* GSAP */
  useEffect(() => {
    loadGSAP().then(() => {
      const { gsap, ScrollTrigger } = window;

      gsap.fromTo('.con-hero-content > *',
        { opacity:0, y:40 },
        { opacity:1, y:0, duration:.8, stagger:.14, ease:'power3.out', delay:.2 }
      );

      gsap.fromTo('.con-form-wrap',
        { opacity:0, x:-50 },
        { opacity:1, x:0, duration:.8, ease:'power3.out',
          scrollTrigger:{ trigger:'.con-main-grid', start:'top 78%' } }
      );
      gsap.fromTo('.con-info-wrap',
        { opacity:0, x:50 },
        { opacity:1, x:0, duration:.8, ease:'power3.out',
          scrollTrigger:{ trigger:'.con-main-grid', start:'top 78%' } }
      );

      gsap.fromTo('.info-card-item',
        { opacity:0, y:30 },
        { opacity:1, y:0, duration:.55, stagger:.1, ease:'power3.out',
          scrollTrigger:{ trigger:'.con-info-wrap', start:'top 80%' } }
      );

      gsap.fromTo('.faq-item',
        { opacity:0, y:28 },
        { opacity:1, y:0, duration:.55, stagger:.08, ease:'power3.out',
          scrollTrigger:{ trigger:'.faq-grid', start:'top 80%' } }
      );

      gsap.fromTo('.map-viz',
        { opacity:0, scale:.95 },
        { opacity:1, scale:1, duration:.8, ease:'power3.out',
          scrollTrigger:{ trigger:'.map-section', start:'top 82%' } }
      );

      gsap.fromTo('.con-section-header',
        { opacity:0, y:30 },
        { opacity:1, y:0, duration:.65, ease:'power3.out',
          scrollTrigger:{ trigger:'.con-section-header', start:'top 85%' } }
      );
    });
    return () => { if (window.ScrollTrigger) window.ScrollTrigger.getAll().forEach(t=>t.kill()); };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(false);
    if (!formData.name.trim())    return setError('Please enter your name');
    if (!formData.email.trim())   return setError('Please enter your email');
    if (!formData.message.trim()) return setError('Please enter your message');
    try {
      setLoading(true);
      const response = await fetch('/send-lead.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const result = await response.json();
      if (result.success) {
        setSuccess(true);
        setFormData({ name:'', email:'', company:'', service:'', message:'' });
        setTimeout(() => setSuccess(false), 6000);
      } else {
        setError(result.message || 'Failed to send message. Please try again.');
      }
    } catch (err) {
      setError('Failed to send. Please try again or email us directly.');
      console.error('Form submission error:', err);
    } finally {
      setLoading(false);
    }
  };

  const infoCards = [
    // { icon: <IconPin/>,   color:'#2f80ed', title:'Office Location',  body: <>Incogniflex Inc.<br/>1 Market Street, Suite 2600<br/>San Francisco, CA 94103</> },
    // { icon: <IconPhone/>, color:'#10b981', title:'Phone',            body: <a href="tel:+14155550100">+1 (415) 555-0100</a> },
    { icon: <IconMail/>,  color:'#56ccf2', title:'Email',            body: <a href="mailto:hello@incogniflex.com">hello@incogniflex.com</a> },
    // { icon: <IconClock/>, color:'#f59e0b', title:'Support Hours',    body: <>24/7 Support Available<br/><span>Avg. response: &lt;1 hour</span></> },
  ];

  const socials = [
    { icon:<IconLinkedIn/>, href:'https://www.linkedin.com/company/incogniflex', label:'LinkedIn' },
    { icon:<IconTwitterX/>, href:'#twitter',  label:'Twitter' },
    { icon:<IconGithub/>,   href:'#github',   label:'GitHub' },
  ];

  const faqs = [
    { question:'What is your typical project timeline?',     answer:'Project timelines vary based on scope and complexity. Most engagements run 3–6 months with agile milestones, though proof-of-concept sprints can ship in under 4 weeks.' },
    { question:'How do you ensure data security?',           answer:'We follow enterprise-grade security practices: SOC 2 Type II, GDPR & HIPAA compliance, end-to-end encryption, zero-trust networking, and regular third-party security audits.' },
    { question:'What support is available post-deployment?', answer:'All enterprise plans include 24/7 monitoring, a dedicated account manager, P1 response time under 15 minutes, and a self-service support portal.' },
    { question:'Can you integrate with existing systems?',   answer:'Absolutely. We specialise in seamless integration with legacy systems, modern SaaS stacks, CRMs, ERPs, and custom APIs — both REST and GraphQL.' },
    { question:'How is pricing structured?',                 answer:'We offer project-based, time-and-materials, and dedicated team arrangements. Most enterprise engagements start from $15k/month. Reach out for a tailored proposal.' },
    { question:'Do you provide training?',                   answer:'Yes — every deployment includes comprehensive training, detailed documentation, and optional on-site workshops so your team can operate and extend the solution confidently.' },
  ];

  const services = ['AI-Powered SaaS','Cloud Engineering','AI Agents','MLOps / AIOps','Vertical AI','Other'];

  return (
    <div className="contact-page">

      {/* ════════════════════ HERO ════════════════════ */}
      <section className="con-hero">
        <ParticleField />
        <div className="con-grid-bg" aria-hidden />
        <div className="con-glow con-glow-l" aria-hidden />
        <div className="con-glow con-glow-r" aria-hidden />
        <div className="con-hero-inner">
          <div className="con-hero-content">
            <span className="con-hero-eyebrow">
              <span className="con-eyebrow-dot" />
              Let's Build Together
            </span>
            <h1 className="con-hero-title">
              Get in <span className="con-hero-accent">Touch</span>
            </h1>
            <p className="con-hero-sub">
              Have a project in mind? We'd love to discuss how Incogniflex can accelerate your
              digital transformation. Expect a reply within 24 hours.
            </p>
            <div className="con-hero-trust">
              {['Rapid Response AI SLA','Zero-Obligation Consultation','Strategic Blueprint Session'].map(t=>(
                <span key={t} className="trust-pill">
                  <IconCheck />{t}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="con-hero-cut" aria-hidden />
      </section>

      {/* ════════════════════ CONTACT GRID ════════════════════ */}
      <section className="con-contact-section">
        <div className="con-container">
          <div className="con-main-grid">

            {/* ── FORM ── */}
            <div className="con-form-wrap">
              <div className="con-form-header">
                <h2 className="con-form-title">Send a Message</h2>
                <p className="con-form-sub">Fill in the details below and we'll get back to you promptly.</p>
              </div>

              <form className="con-form" onSubmit={handleSubmit} ref={formRef} noValidate>

                <div className="form-row">
                  <div className={`form-group ${focused==='name'?'focused':''} ${formData.name?'has-value':''}`}>
                    <label htmlFor="name">Full Name <span>*</span></label>
                    <input type="text" id="name" name="name" value={formData.name}
                      onChange={handleChange} onFocus={()=>setFocused('name')} onBlur={()=>setFocused('')}
                      placeholder="Your full name" disabled={loading} autoComplete="name" />
                    <div className="input-line" />
                  </div>
                  <div className={`form-group ${focused==='email'?'focused':''} ${formData.email?'has-value':''}`}>
                    <label htmlFor="email">Work Email <span>*</span></label>
                    <input type="email" id="email" name="email" value={formData.email}
                      onChange={handleChange} onFocus={()=>setFocused('email')} onBlur={()=>setFocused('')}
                      placeholder="you@company.com" disabled={loading} autoComplete="email" />
                    <div className="input-line" />
                  </div>
                </div>

                <div className="form-row">
                  <div className={`form-group ${focused==='company'?'focused':''} ${formData.company?'has-value':''}`}>
                    <label htmlFor="company">Company</label>
                    <input type="text" id="company" name="company" value={formData.company}
                      onChange={handleChange} onFocus={()=>setFocused('company')} onBlur={()=>setFocused('')}
                      placeholder="Your company" disabled={loading} autoComplete="organization" />
                    <div className="input-line" />
                  </div>
                  <div className={`form-group select-group ${focused==='service'?'focused':''} ${formData.service?'has-value':''}`}>
                    <label htmlFor="service">Service Interest</label>
                    <select id="service" name="service" value={formData.service}
                      onChange={handleChange} onFocus={()=>setFocused('service')} onBlur={()=>setFocused('')}
                      disabled={loading}>
                      <option value="">Select a service…</option>
                      {services.map(s=><option key={s} value={s}>{s}</option>)}
                    </select>
                    <div className="select-chevron"><IconChevron /></div>
                    <div className="input-line" />
                  </div>
                </div>

                <div className={`form-group textarea-group ${focused==='message'?'focused':''} ${formData.message?'has-value':''}`}>
                  <label htmlFor="message">Message <span>*</span></label>
                  <textarea id="message" name="message" value={formData.message}
                    onChange={handleChange} onFocus={()=>setFocused('message')} onBlur={()=>setFocused('')}
                    placeholder="Tell us about your project, goals, and timeline…"
                    rows="5" disabled={loading} />
                  <div className="input-line" />
                  <span className="char-count">{formData.message.length} / 2000</span>
                </div>

                {error && (
                  <div className="form-error" role="alert">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    {error}
                  </div>
                )}

                {success && (
                  <div className="form-success" role="status">
                    <div className="success-icon"><IconCheck /></div>
                    <div>
                      <strong>Message sent!</strong>
                      <span>We'll get back to you within 24 hours.</span>
                    </div>
                  </div>
                )}

                <button type="submit" className={`con-submit ${loading?'loading':''} ${success?'done':''}`} disabled={loading||success}>
                  {loading ? (
                    <><span className="spinner" /><span>Sending…</span></>
                  ) : success ? (
                    <><IconCheck /><span>Message Sent!</span></>
                  ) : (
                    <><span>Send Message</span><IconSend /></>
                  )}
                  <span className="submit-shine" />
                </button>

              </form>
            </div>

            {/* ── INFO PANEL ── */}
            <div className="con-info-wrap">
              <div className="con-form-header">
                <h2 className="con-form-title">Contact Information</h2>
                <p className="con-form-sub">Reach us through any of the channels below.</p>
              </div>

              <div className="info-cards">
                {infoCards.map((c, i) => (
                  <div key={i} className="info-card-item" style={{ '--ic': c.color }}>
                    <div className="info-icon-wrap" style={{ borderColor:c.color+'33', background:c.color+'14', color:c.color }}>
                      {c.icon}
                    </div>
                    <div className="info-body">
                      <h4 className="info-title">{c.title}</h4>
                      <p className="info-text">{c.body}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* socials */}
              <div className="con-socials">
                <p className="socials-label">Follow us</p>
                <div className="socials-row">
                  {socials.map(s=>(
                    <a key={s.label} href={s.href} className="social-btn" aria-label={s.label}>
                      {s.icon}
                    </a>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ════════════════════ FAQ ════════════════════ */}
      <section className="faq-section">
        <div className="con-container">
          <div className="con-section-header">
            <span className="con-section-eyebrow">💬 FAQ</span>
            <h2 className="con-section-title">Frequently Asked <span className="con-accent">Questions</span></h2>
            <p className="con-section-sub">Everything you need to know before reaching out.</p>
          </div>
          <div className="faq-grid">
            {faqs.map((faq, i) => <FAQItem key={i} faq={faq} index={i} />)}
          </div>
        </div>
      </section>

      {/* ════════════════════ MAP ════════════════════ */}
      <section className="map-section">
        <div className="con-container">
          <div className="con-section-header">
            <span className="con-section-eyebrow">🌍 Global Reach</span>
            <h2 className="con-section-title">Our <span className="con-accent">Presence</span></h2>
            <p className="con-section-sub">Serving clients worldwide with local expertise and global standards.</p>
          </div>
          <div className="presence-grid">
            {[
              { city: 'San Francisco', country: 'USA', icon: '🇺🇸', teams: 'Product & Engineering' },
              { city: 'Bengaluru', country: 'India', icon: '🇮🇳', teams: 'Engineering & Support' },
              { city: 'Singapore', country: 'Singapore', icon: '🇸🇬', teams: 'APAC Operations' },
              { city: 'London', country: 'UK', icon: '🇬🇧', teams: 'EMEA Sales' },
            ].map((loc, i) => (
              <div key={i} className="presence-card">
                <div className="presence-icon">{loc.icon}</div>
                <h3 className="presence-city">{loc.city}</h3>
                <p className="presence-country">{loc.country}</p>
                <span className="presence-teams">{loc.teams}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;